<template>
    <nav class="navbar navbar-full navbar-inverse navbar-fixed-top mai-top-header">
        <div class="container">
            <a href="#" @click.prevent="resetContext" class="navbar-brand"><img class="logo" src="/static/logo.png" /> SensorCLIP</a>
            <links></links>

            <!--Left Menu-->
            <ul class="nav navbar-nav mai-top-nav">
            </ul>

            <!-- Language menu -->
            <div class="mr-3">
                <languageSwitcher></languageSwitcher>
            </div>

            <!-- Top menu -->
            <top-menu></top-menu>

            <!--User Menu-->
            <user-menu></user-menu>
        </div>
    </nav>
</template>

<script>
    import links from "./links.vue"
    import userMenu from "./usermenu.vue"
    import topMenu from "./topmenu.vue"
    import languageSwitcher from "../snippets/language-switcher.vue"

    export default {
        components: {
            userMenu,
            topMenu,
            links,
            languageSwitcher
        },
        methods: {
            resetContext(){
                this.$store.commit("clearContext");
                this.$router.push({name: "dashboard"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/topbar/topbar.vue